import type { PassportState } from './types';

const initialState: PassportState = {
  initialized: false,
  created: false,
  loaded: false,
  popularLocations: [],
  searchLocations: [],
  zoomLevel: 10,
  recentLocations: [],
  // @ts-expect-error: https://gotinder.atlassian.net/browse/TDP-119230
  location: {},
  // @ts-expect-error: https://gotinder.atlassian.net/browse/TDP-119230
  markerLocation: {},
  loadingTravelLocation: false,
  // @ts-expect-error: https://gotinder.atlassian.net/browse/TDP-119230
  markerPosition: {},
  hideLocationInfo: true,
};

export default initialState;
